import React from "react";
import SignUpForm from "../UI/./components/auth/SignupForm";

const SignUpPage = () => {
    return <SignUpForm />;
};

export default SignUpPage;